<template>
    <v-layout-text :label="label" :model.sync="content"></v-layout-text>
</template>
<script>
    import mixins from "./mixin.js";
    export default {
        mixins: [mixins],
        props: ["options", "model", "label", "render", "select"],
        mounted(){
            $(this.$el).find("input").autocomplete({
                source: this.options,
                select: this.select                
            }).autocomplete("instance")._renderItem = this.render;
            $(this.$el).find("input").attr("autocomplete", "new-password");

        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/layout/autocomplete.vue